<template>
	<v-card class="mb-1">
		<v-card-title>
			<div v-html="alert.title_pt"/>
			<v-spacer></v-spacer>
			<v-btn class="ml-3" icon @click="showEdit = true">
				<v-icon color="primary">mdi-pencil</v-icon>
			</v-btn>
			<v-btn class="ml-1" icon @click="showDeleteAlert = true">
				<v-icon color="primary">mdi-delete</v-icon>
				<DeleteConfirmationDialog v-model="showDeleteAlert" item="alert" @delete="deleteAlert" />
			</v-btn>
		</v-card-title>
		<v-card-subtitle>
			<v-chip v-if="alert.active" small><translate>Active</translate></v-chip>
		</v-card-subtitle>
		<v-card-text>
			<div v-html="alert.text_pt"/>
		</v-card-text>
		<v-dialog v-model="showEdit" max-width="70%">
			<v-card>
				<v-card-title class="title primary--text mb-2 secondary">
					<translate>Edit</translate>
				</v-card-title>
				<v-card-text class="pt-2">
					<v-form ref="alertForm" v-model="validForm">
						<v-row no-gutters>
              <v-col cols="12">
								Título PT
								<RichTextEditor key="pt-title" ref="titlePT" :text="alert.title_pt" />
							</v-col>
              <v-col cols="12">
								Título EN
								<RichTextEditor key="en-title" ref="titleEN" :text="alert.title_en" />
							</v-col>
              <v-col cols="12">
								Título ES
								<RichTextEditor key="es-title" ref="titleES" :text="alert.title_es" />
							</v-col>
							<v-col cols="12">
								PT
								<RichTextEditor key="pt-text" ref="textPT" :text="alert.text_pt" />
							</v-col>
							<v-col cols="12">
								EN
								<RichTextEditor key="en-text" ref="textEN" :text="alert.text_en" />
							</v-col>
							<v-col cols="12">
								ES
								<RichTextEditor key="es-text" ref="textES" :text="alert.text_es" />
							</v-col>
              <v-col cols="6" class="mt-2">
								<v-checkbox
									v-model="alert.active"
									class="mt-0 pt-0"
									color="primary"
									:label="$gettext('Active')"
									hide-details
								/>
							</v-col>
							<v-col cols="6" class="mt-2">
								<v-img
									v-if="alert.image_url"
									:src="alert.image_url"
									contain
								/>
								<v-file-input
									accept="image/png, image/jpeg, image/bmp"
									label="Imagem"
									v-model="imageUpload"
									outlined
									class="px-2"
									hide-details
								></v-file-input>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-btn color="primary darken-1" text @click="showEdit = false">
						<translate key="close">Close</translate>
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn color="primary darken-1" text @click="editAlert">
						<translate key="save">Save</translate>
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-card>
</template>

<script>
import DeleteConfirmationDialog from "@/components/DeleteConfirmationDialog.vue";
import axios from "axios";
import RichTextEditor from "@/components/RichTextEditor.vue";

export default {
  name: "Alert",
  props: ["alert"],
  components: {
		DeleteConfirmationDialog,
		RichTextEditor
  },
  data: () => ({
    showEdit: false,
		validForm: false,
		showDeleteAlert: false,
		imageUpload: null
  }),
  computed: {
		required() {
			return value => !!value || this.$gettext("Required.");
		}
  },
  methods: {
    editAlert() {
      if (this.$refs.alertForm.validate()) {
        const form = new FormData();
        form.append("title_pt", this.$refs.titlePT.getHTML());
        form.append("title_en", this.$refs.titleEN.getHTML());
        form.append("title_es", this.$refs.titleES.getHTML());
				form.append("text_pt", this.$refs.textPT.getHTML());
				form.append("text_en", this.$refs.textEN.getHTML());
				form.append("text_es", this.$refs.textES.getHTML());
				form.append("active", this.alert.active);
				if(this.imageUpload) form.append("image_upload", this.imageUpload);
				axios
					.post("/admin/alert/" + this.alert.id + "/edit", form)
					.then(response => {
						console.log(response.data);
						if (response.data.result == "ok") {
							this.alert = response.data.alert;
							this.showEdit = false;
							this.imageUpload = null;
						}
					})
					.catch(error => console.log(error));
			}
    },
    deleteAlert() {
      axios
				.post("/admin/alert/" + this.alert.id + "/delete")
				.then(response => {
					console.log(response.data);
					if (response.data.result == "deleted") this.$emit("delete-alert", this.alert);
					else this.showError = true;
				})
				.catch(error => console.log(error));
    }
  }
}
</script>